import React from 'react';
import { Box, Page } from '@wix/design-system';
import {
  EntityPageHeaderElement,
  EntityPageSkeletonHeader,
} from '../../components/EntityPageHeader';
import { useEntityPageContext } from '../../providers';
import { EntityPageActionButtons } from '../../components/EntityPage';

export function useEntityPageHeader(child: EntityPageHeaderElement) {
  const state = useEntityPageContext();
  const dataHook = 'entity-page-header';

  return state.isFetching ? (
    <EntityPageSkeletonHeader
      key={child.key}
      dataHook={dataHook}
      breadcrumbs={child.props.breadcrumbs}
      onBackClicked={() => state.navigateToParent()}
      showSubtitle={child.props.subtitle !== undefined}
    />
  ) : (
    <Page.Header
      key={child.key}
      dataHook={dataHook}
      title={child.props.title.text}
      subtitle={child.props.subtitle?.text}
      actionsBar={
        <Box gap="SP2">
          {child.props.moreActions}
          <EntityPageActionButtons />
        </Box>
      }
      breadcrumbs={child.props.breadcrumbs}
      showBackButton
      onBackClicked={() => state.navigateToParent()}
    />
  );
}
